<template>
  <div class="fmhind-switcher">
    <div
      v-for="option in options"
      :key="option"
      class="fmhind-switcher__button"
      :class="{ 'fmhind-switcher__button--active': value === option }"
      @click="switchOption(option)"
    >
      {{ option }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Switcher',
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  methods: {
    switchOption(option) {
      this.$emit('input', option);
    }
  }
};
</script>

<style lang="scss">
.fmhind-switcher {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: $unit * 2;
}

.fmhind-switcher__button {
  @extend %text-md;
  padding: $padding-sm $padding-lg;
  transition: background-color 0.3s ease-in-out;
  background: white;
  border: 1px solid $color-primary;
  color: $color-primary;
  cursor: pointer;

  &--active {
    background: $color-primary;
    border: 1px solid $color-primary;
    color: white;
  }
}
</style>
